<script setup lang="ts">
import { removePageFromUrl } from "../../utils/url"

const { pages } = useSwiftSearchHelper()
const route = useRoute()
const currentPage = computed(() =>
  route.params.page ? parseInt(route.params.page as string) : 1
)
const queries = computed(() => route.query)

const { overflowAuto } = useBodyOverflowManager()

watchDebounced(
  queries,
  () => {
    if (process.server) return
    const { query, path } = route
    const pathWithoutPage = removePageFromUrl(path).split("?")[0]
    const queryTmp = { ...query }
    delete queryTmp.page
    navigateTo({
      path: pathWithoutPage,
      query: queryTmp
    })
    useTimeoutFn(() => {
      overflowAuto()
    }, 1000)
  },
  {
    debounce: 500,
    deep: true
  }
)
</script>
<template>
  <NavigationPaginator
    v-if="pages > 1"
    class="mx-auto mt-2"
    :current-page="currentPage"
    :total-pages="pages"
  />
</template>
